'use client';

import { useEffect, useRef, useState } from 'react';
import { Modal } from '@/components/ui/Modal';
import { PopupForm } from '@/components/ui/PopupForm';

const POPUP_DELAY_MS = 12000; // Show first popup after 2 minutes - 12000
const POPUP_INTERVAL_MS = 100000; // Re-show every 2 minutes if still on page - 12000

export function TimedPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const intervalRef = useRef<number | null>(null);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    // Initial delay before first appearance
    timeoutRef.current = window.setTimeout(() => {
      setIsOpen(true);

      // After first show, repeat on interval
      intervalRef.current = window.setInterval(() => {
        setIsOpen(true);
      }, POPUP_INTERVAL_MS);
    }, POPUP_DELAY_MS);

    return () => {
      if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <PopupForm
        onSubmit={() => setIsOpen(false)}
        showTitle={true}
      />
    </Modal>
  );
}
